import { useTranslation } from 'next-i18next'
import clsx from 'clsx'

import { SectionEditButton } from 'components/buttons'
import { useOrgLanguages } from 'components/Org/components'

import getFlag from 'utils/getFlag'

import { ICVLanguagesProps } from './types'

const CVLanguages = ({ languages, editable, onEdit }: ICVLanguagesProps) => {
  const { t } = useTranslation(['cv_modal'])
  const { translatedLanguages } = useOrgLanguages({ languages })
  return (
    <div className="pt-2">
      <div className="flex items-center justify-between">
        <h2 className="pb-6 text-2xl font-bold tracking-wide">
          {t('fields.languages', { ns: 'cv_modal' })}
          <i className="dot"></i>
        </h2>
        {editable && (
          <SectionEditButton
            data-cy="languages-modal"
            onClick={() => onEdit?.(null)}
          />
        )}
      </div>
      <div
        className={`flex flex-wrap gap-x-2 ${
          languages?.length ? 'gap-y-2' : ''
        }  pb-10`}
      >
        {translatedLanguages.map((lang) => (
          <span
            key={lang?.name}
            className="rounded-full border border-gray-300 px-4 py-2"
          >
            {getFlag(lang?.name) ? (
              <span
                className={clsx('fp fp-md fp-rounded', getFlag(lang?.name))}
              ></span>
            ) : null}
            <span className="ml-2">
              {lang?.label}
              {lang?.languageLevel ? ` - ${lang.languageLevel}` : ''}
            </span>
          </span>
        ))}
      </div>
    </div>
  )
}

export default CVLanguages
